import { generateRandomString } from '../utils/stringHelper';
import { HttpClient } from '../utils/httpClient';

const PATH = {
    checkout: '/checkout',
};

const createOrder = (payload, callback, error, loader) => {
    const { start, stop } = loader(generateRandomString(5));
    start();
    return HttpClient.post(`${PATH.checkout}`, payload).then(callback).catch(error).finally(stop);
};


export const CheckoutService = {
    createOrder,
};